export default __webpack_public_path__ + "static/media/SCW_Info_Eng.d0055597.pdf";